import * as Enums from '@/utils/enums';
import Helper from "@/utils/helper";

// How linked quotes, invoices, purchase orders, queries and projects are labelled in link lists and pickers

export const formatMoney = (value?: number | string | null, symbol?: string) => {
  if (value === null || value === undefined || value === '') return '';
  const formatted = Helper.getCurrencyValue(value);
  const s = symbol || 'R';
  return `${s} ${formatted}`;
};

export const getModuleSingular = (module: number) => {
  switch (module) {
    case Enums.Module.Quote: return 'Quote';
    case Enums.Module.Invoice: return 'Invoice';
    case Enums.Module.PurchaseOrder: return 'Purchase Order';
    case Enums.Module.Project: return 'Project';
    case Enums.Module.Query: return 'Query';
    default: return 'Item';
  }
};

export const getItemStatus = (module: number, itm: any): { label?: string; color?: string } => {
  if (module === Enums.Module.Invoice) {
    const label = itm.InvoiceStatusName || itm.StatusName || (itm.InvoiceStatus !== undefined ? Enums.getEnumStringValue(Enums.InvoiceStatus, itm.InvoiceStatus) : undefined) || itm.Status || undefined;
    const map: Record<string, string> = {
      Draft: 'gray',
      Unpaid: 'blue',
      Overdue: 'red',
      Paid: 'green',
      Cancelled: 'gray',
      Approved: 'blue',
    };
    const color = label ? (map[label] || 'blue') : undefined;
    return { label, color };
  }
  if (module === Enums.Module.Quote) {
    const label = itm.QuoteStatusName || itm.StatusName || (itm.QuoteStatus !== undefined ? Enums.getEnumStringValue(Enums.QuoteStatus, itm.QuoteStatus) : undefined) || itm.Status || undefined;
    const map: Record<string, string> = {
      Draft: 'gray',
      Accepted: 'green',
      Declined: 'red',
      Invoiced: 'grape',
      Expired: 'yellow',
      Approved: 'blue',
      Cancelled: 'gray',
    };
    const color = label ? (map[label] || 'blue') : undefined;
    return { label, color };
  }
  if (module === Enums.Module.PurchaseOrder) {
    const label = itm.PurchaseOrderStatusName || itm.StatusName || (itm.PurchaseOrderStatus !== undefined ? Enums.getEnumStringValue(Enums.PurchaseOrderStatus, itm.PurchaseOrderStatus) : undefined) || undefined;
    return { label, color: label ? 'blue' : undefined };
  }
  // Queries: usually no status
  return {};
};

export const getItemDocNum = (module: number, itm: any) => {
  switch (module) {
    case Enums.Module.Invoice: return itm.InvoiceNumber || itm.InvoiceNum || itm.InvoiceCode || itm.Number || itm.Code || '';
    case Enums.Module.Quote: return itm.QuoteNumber || itm.QuoteNum || itm.QuoteCode || itm.Number || itm.Code || '';
    case Enums.Module.PurchaseOrder: return itm.PurchaseOrderNumber || itm.PONumber || itm.Number || '';
    case Enums.Module.Project: return itm.ProjectNumber || itm.ProjectNum || itm.Number || '';
    case Enums.Module.Query: return itm.QueryCode || itm.Code || '';
    default: return itm.Description || 'Item';
  }
};

export const getItemAmount = (module: number, itm: any) => {
  if (module === Enums.Module.Invoice || module === Enums.Module.Quote || module === Enums.Module.PurchaseOrder) {
    return itm.TotalExclusive ?? itm.TotalExcl ?? itm.SubTotalExclusive ?? itm.GrandTotal ?? itm.Total ?? null;
  }
  return null;
};
